import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import produce from "immer";

import { fetcher } from "../../client";
import {
  updateProfile,
  updateStorageToken,
  changePlan,
  requestDemo,
  requestPayment,
} from "../../actions/profile";

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation((payload) => fetcher(updateProfile(payload)), {
    onSuccess: (data, newProfile) => {
      queryClient.setQueryData(["profile", newProfile._id], () => newProfile);

      toast.success(t("successMessages.updatedProfile"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        toastId: "profile-success-message",
      });
    },
    onError: () => {
      toast.error(t("errorMessages.updatedProfile"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    },
  });
}

export function useUpdateStorageToken(options = {}) {
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(updateStorageToken(payload)), {
    ...options,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        ["profile"],
        produce((draft) => {
          if (!draft.externalStorageConfig) draft.externalStorageConfig = {};
          if (!draft.externalStorageConfig.dropbox)
            draft.externalStorageConfig.dropbox = {};
          draft.externalStorageConfig.dropbox.isConnected = true;
        })
      );

      if (options.onSuccess) options.onSuccess(data, variables);
    },
    onError: (error, variables) => {
      if (options.onError) options.onError(error, variables);
    },
  });
}

export function useChangePlan(options = {}) {
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(changePlan(payload)), {
    ...options,
    onSuccess: (data, variables) => {
      if (options.onSuccess) options.onSuccess(data, variables);
      queryClient.invalidateQueries("profile");
    },
  });
}

export function useRequestDemo(options = {}) {
  return useMutation((payload) => fetcher(requestDemo(payload)), {
    ...options,
    onSuccess: (data, variables) => {
      if (options.onSuccess) options.onSuccess(data, variables);
      toast.success("Hemos recibido tu solicitud", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "success",
      });
    },
    onError: (error, variables) => {
      if (options.onError) options.onError(error, variables);
      toast.error("Error en el envio.", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "error",
      });
    },
  });
}
export function useRequestPayment(options = {}) {
  return useMutation(
    (payload) => fetcher(requestPayment(payload)),

    {
      ...options,
      onSuccess: (data, variables) => {
        if (options.onSuccess) options.onSuccess(data, variables);
        toast.success("Hemos recibido tu solicitud pago", {
          position: toast.POSITION.TOP_RIGHT,
          toastId: "success",
        });
      },
      onError: (error, variables) => {
        if (options.onError) options.onError(error, variables);
        toast.error("Error en el envio.", {
          position: toast.POSITION.TOP_RIGHT,
          toastId: "error",
        });
      },
    }
  );
}
